const siteConfig = {
  titokDev: {
    title: '18禁Porn',
    logo: require('./assets/logo/18porn.png'),
    launchLogo: require('./assets/launch/18pornLogo.png'),
    launchTitle: require('./assets/launch/18pronLaunchTitle.png'),
    favicon: require('./assets/favicon/18porn.png'),
    uploadCover: require('./assets/placeholder/18porn.png'),
    noData: require('./assets/noData/18porn.png'),
    customerBg: require('./assets/customerBg/18porn.png')
  },
  titok: {
    title: '18禁Porn',
    logo: require('./assets/logo/18porn.png'),
    launchLogo: require('./assets/launch/18pornLogo.png'),
    launchTitle: require('./assets/launch/18pronLaunchTitle.png'),
    favicon: require('./assets/favicon/18porn.png'),
    uploadCover: require('./assets/placeholder/18porn.png'),
    noData: require('./assets/noData/18porn.png'),
    customerBg: require('./assets/customerBg/18porn.png')
  },
  '99x': {
    title: '久久插',
    logo: require('./assets/logo/99x.png'),
    launchLogo: require('./assets/launch/99xLogo.png'),
    launchTitle: require('./assets/launch/99xLaunchTitle.png'),
    favicon: require('./assets/favicon/99x.png'),
    uploadCover: require('./assets/placeholder/99x.png'),
    noData: require('./assets/noData/99x.png'),
    customerBg: require('./assets/customerBg/99x.png')
  }
};

export default siteConfig[SITE_CHANNEL];
